"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _reactReduxI18n = require("react-redux-i18n");

var _Icon = _interopRequireDefault(require("./Icon"));

var _jsxRuntime = require("react/jsx-runtime");

function HelpMenuButton(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_core.Fab, {
    variant: "extended",
    size: "medium",
    color: "inherit",
    onClick: onClick,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex-container",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
        icon: "question-mark",
        size: 18
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
        value: "menu.help"
      })]
    })
  });
}

HelpMenuButton.propTypes = {
  onClick: _propTypes.default.func.isRequired
};
var _default = HelpMenuButton;
exports.default = _default;
//# sourceMappingURL=HelpMenuButton.js.map